module.exports = __webpack_public_path__ + "web/img/hcip.580a0049.png";